import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Std$Bolt0 from "bolt0/./std.bs.js";
import * as Caml_string from "bs-platform/lib/es6/caml_string.js";
import * as Caml_js_exceptions from "bs-platform/lib/es6/caml_js_exceptions.js";
import * as Lang_var_bs$SolvuuApi0 from "./lang_var_bs.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function is_alpha_lower(param) {
  return !(param > 122 || param < 97);
}

function is_alpha_upper(param) {
  return !(param > 90 || param < 65);
}

function is_num(param) {
  return !(param > 57 || param < 48);
}

function is_symbol(param) {
  if (param >= 48) {
    if (param >= 63) {
      return param === 126;
    } else {
      return param >= 60;
    }
  } else if (param !== 44) {
    return param >= 42;
  } else {
    return false;
  }
}

function of_string(x) {
  var raise = Curry._1(Std$Bolt0.failwithf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["Var_parse_error: ",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* End_of_format */
  0])]), "Var_parse_error: %s"]), x);

  switch (x) {
    case "":
    case "_":
      return Curry._1(raise,
      /* () */
      0);

    default:
      var match = is_symbol(Caml_string.get(x, 0));

      if (match) {
        for (var i = 1, i_finish = x.length - 1 | 0; i <= i_finish; ++i) {
          if (!is_symbol(Caml_string.get(x, i))) {
            Curry._1(raise,
            /* () */
            0);
          }
        }
      } else {
        var match$1 = !(is_alpha_lower(Caml_string.get(x, 0)) || is_alpha_upper(Caml_string.get(x, 0)) || Caml_string.get(x, 0) === 95 || Caml_string.get(x, 0) === 64);

        if (match$1) {
          Curry._1(raise,
          /* () */
          0);
        }

        for (var i$1 = 1, i_finish$1 = x.length - 1 | 0; i$1 <= i_finish$1; ++i$1) {
          var match$2 = !(is_alpha_lower(Caml_string.get(x, i$1)) || is_alpha_upper(Caml_string.get(x, i$1)) || is_num(Caml_string.get(x, i$1)) || Caml_string.get(x, i$1) === 95 || Caml_string.get(x, i$1) === 45 || Caml_string.get(x, i$1) === 47);

          if (match$2) {
            Curry._1(raise,
            /* () */
            0);
          }
        }
      }

      return x;
  }
}

function to_string(x) {
  return x;
}

function of_string$1(x) {
  try {
    return (
      /* `Ok */
      [17724, of_string(x)]
    );
  } catch (raw_exn) {
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);

    if (exn[0] === Caml_builtin_exceptions.failure) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      throw exn;
    }
  }
}

function equal(x, y) {
  var match = $$String.compare(x, y);
  var switcher = match + 1 | 0;

  if (switcher > 2 || switcher < 0) {
    throw [Caml_builtin_exceptions.assert_failure,
    /* tuple */
    ["lang_var.ml", 101, 9]];
  } else {
    return switcher === 1;
  }
}

function wrap(x) {
  return x;
}

function unwrap(x) {
  return x;
}

var Exn = {
  of_string: of_string
};
var compare = $$String.compare;
var Json = Lang_var_bs$SolvuuApi0;
export { of_string$1 as of_string, to_string, Exn, compare, equal, Json, wrap, unwrap };
/* No side effect */